import { Flex, Icon, Box } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { FormattedDurationSinceDetailed } from '../../../common/components/formatted-duration-since-detailed';
import { Tooltip } from '../../../common/components/tooltip';
import type { ColumnDefinitionData } from '../../../queues/column-definition.enum';
import { BaseQueueCell } from '../../../queues/components/base-queue-cell';
import { useQueueStore } from '../../../queues/context/use-queue-store';
import { getFormattedDate } from '../../../queues/utils/get-formatted-date';
import { UnitQueueRowData } from '../../../socket/stream-types';
import { UnitQueueStore } from '../../../unit-queues/store/unit-queue-store';
import { UnitQueueWireDto } from '@mark43/cad-api';
import { useContextMenuStateWrite } from '../../../queues/context/use-context-menu-state';
import { colors } from '../../../colors/colors';

export const MinutesInStatusCell = observer(function MinutesInStatusCell(props: {
    data: UnitQueueRowData;
    columnDefinition: ColumnDefinitionData<'MINUTES_IN_STATUS'>;
}): React.ReactElement {
    const store = useQueueStore() as UnitQueueStore;
    const unitTimer = store.getUnitTimer(props.data.id);
    const contextMenuStateWrite = useContextMenuStateWrite();
    const showFullRowUnitTimerUpdates = store.workspacePanel.queue.fullRowUnitTimerUpdates;

    if (!props.data.timeInStatusDateTime) {
        return <BaseQueueCell />;
    }
    const statusStarted = new Date(props.data.timeInStatusDateTime);
    return (
        <Tooltip overlay={getFormattedDate(props.data.timeInStatusDateTime)}>
            <BaseQueueCell
                onContextMenu={
                    unitTimer?.state === 'ALERTING'
                        ? () =>
                              contextMenuStateWrite({
                                  kind: 'UNIT_TIMER',
                                  data: props.data as UnitQueueWireDto,
                              })
                        : undefined
                }
            >
                <Flex
                    align="center"
                    justify="space-between"
                    gap="1"
                    data-testid="minutes-in-status-cell"
                >
                    <Box as="span" minWidth={0} overflow="hidden" textOverflow="ellipsis">
                        <FormattedDurationSinceDetailed
                            date={statusStarted}
                            signal={unitTimer?.state}
                        />
                    </Box>
                    {!showFullRowUnitTimerUpdates && unitTimer?.state === 'ALERTING' ? (
                        <Icon
                            icon="Timer"
                            color={colors.unitTimerIcon}
                            className="queue-cell-icon"
                            data-testid="unit-timer-icon"
                        />
                    ) : (
                        // Reserve the icon's space so the duration doesn't shift when the timer alerts
                        <Box className="queue-cell-icon" />
                    )}
                </Flex>
            </BaseQueueCell>
        </Tooltip>
    );
});
